import React, { useState, useEffect, useRef } from 'react';
import { usePortfolio } from '../../context/PortfolioContext';
import PortfolioAllocationBoxV2 from '../../components/PortfolioV2/PortfolioAllocationBoxV2';
import PortfolioAllocationBoxV2Admin from '../../components/PortfolioV2/PortfolioAllocationBoxV2Admin';
import { useExchangeRates } from '../../context/ExchangeRateContext';
import AddEditPortfolioV2Modal from '../../components/PortfolioV2/AddEditPortfolioV2Modal';
import { deletePortfolioTwo, requestDeleteV2Portfolio, updateV2PortfolioVisibility,archiveAdminPortfolio } from '../../composables/fetchAPI'; // ✅ 1. Import API เข้ามา
import { toast } from 'react-hot-toast';
import { useLocation, useNavigate } from 'react-router-dom';
import ConfigTargetPortRatio from '../../components/ConfigTargetPortRatio'; // นำเข้า Component จาก V1
import { useUser } from '../../context/UserContext';

const PortfolioDashboardV2: React.FC = () => {
  const { userPortfolios, adminPortfolios, loading, refreshUserPortfolios, refreshAdminPortfolios,displayMode,setDisplayMode,refreshShayPortfolios,shayPortfolios} = usePortfolio();
  const { userInfo } = useUser();
  const isAdmin = Boolean(userInfo?.isAdmin);
  const [isPortModalOpen, setIsPortModalOpen] = useState(false);
  const [editPortfolioData, setEditPortfolioData] = useState<any | null>(null);
  const [currency, setCurrency] = useState<'USD' | 'THB'>('USD');
  const [isConfigPortPopupOpen, setIsConfigPortPopupOpen] = useState(false);
  const [selectedPortfolioForConfig, setSelectedPortfolioForConfig] = useState<any | null>(null);
  const location = useLocation();
  const navigate = useNavigate();
  // ✅ เช็คจาก URL ตรงๆ เลยว่าตอนนี้อยู่หน้า "แอดมิน" หรือ "พอร์ตของฉัน"
  const isAdminView = location.pathname.includes('/admin');

  const handleCurrencyToggle = () => {
    setCurrency((prev) => (prev === 'USD' ? 'THB' : 'USD'));
  };

  const { exchangeRates } = useExchangeRates();
  
// ✅ 2. สร้างแม่กุญแจเช็คว่านี่คือการ "โหลดครั้งแรก" หรือไม่
  const isFirstRender = useRef(true);
// นำฟังก์ชันเปิด-ปิด Popup จาก V1 มาใส่
  const handleOpenConfigPopup = (portfolio: any) => {
    setSelectedPortfolioForConfig(portfolio);
    setIsConfigPortPopupOpen(true);
  };
  // ✅ 3. ปรับ useEffect ให้ฉลาดขึ้น
  useEffect(() => {
    // ถ้าเพิ่งเปิดเว็บเข้ามาครั้งแรก ให้ข้ามไปเลย (เพราะ PortfolioContext กำลังดึงให้อยู่แล้ว)
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return; 
    }

    // แต่ถ้าเป็นการกดคลิกสลับหน้าไปมา ให้ดึงข้อมูลให้ตรงกับหน้าที่อยู่
    if (isAdminView) {
      refreshAdminPortfolios();
    } else {
      refreshUserPortfolios();
      if(isAdmin){
         refreshShayPortfolios()
      }
     
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAdminView]);

  const handleAddPortfolio = () => {
    setEditPortfolioData(null);
    setIsPortModalOpen(true);
  };

  const handleEditPortfolio = (portfolio: any) => {
    setEditPortfolioData(portfolio);
    setIsPortModalOpen(true);
  };
const handleDeletePortfolio = async (portfolio: any) => {
  const idToDelete = portfolio.portfolioId || portfolio.portId || portfolio.id || portfolio.adminPortfolioId;
  const toastId = `confirm-${idToDelete}`;

  toast((t) => (
    <div className="flex flex-col gap-3">
      <span className="font-bold text-sm">
        คุณแน่ใจหรือไม่ที่จะลบพอร์ต "{portfolio.name}"?
      </span>
      <div className="flex gap-2 justify-end">
        <button
          onClick={async () => {
            toast.dismiss(t.id);
            
            try {
              // ✅ เช็คว่าถ้ามี p.slug ให้ใช้ endpoint archiveAdminPortfolio
              if (portfolio.slug) {
                await archiveAdminPortfolio(idToDelete);
              } else if (displayMode === 'V1') {
                await deletePortfolioTwo(idToDelete);
              } else {
                await requestDeleteV2Portfolio(idToDelete, 'Delete portfolio');
              }

              toast.success('ลบพอร์ตเรียบร้อยแล้ว');
              
              // รีเฟรชข้อมูลทั้งพอร์ตปกติและพอร์ตแอดมิน
              await refreshUserPortfolios();
              await refreshAdminPortfolios();
              await refreshShayPortfolios();

            } catch (error) {
              console.error('Delete error:', error);
              toast.error('ไม่สามารถลบพอร์ตได้');
            }
          }}
          className="bg-red-500 hover:bg-red-600 text-white px-3 py-1 rounded text-xs font-bold transition-colors"
        >
          ยืนยันลบ
        </button>
        <button
          onClick={() => toast.dismiss(t.id)}
          className="bg-gray-500 hover:bg-gray-600 text-white px-3 py-1 rounded text-xs font-bold transition-colors"
        >
          ยกเลิก
        </button>
      </div>
    </div>
  ), {
    id: toastId,
    duration: 5000,
  });
};
// ✅ 2. สร้างฟังก์ชันเปิด-ปิดสถานะนำเข้า
  const handleToggleVisibility = async (portfolio: any) => {
    try {
      const idToUpdate = portfolio.portfolioId || portfolio.portId || portfolio.id;
      const currentStatus = portfolio.visibilityStatus || 'private';
      const newStatus = currentStatus === 'public' ? 'private' : 'public';
      
      await updateV2PortfolioVisibility(idToUpdate, newStatus);
      
      toast.success(newStatus === 'public' ? 'นำเข้าพอร์ตสำเร็จ' : 'ยกเลิกการนำเข้าสำเร็จ');
      
      if (isAdminView) {
        await refreshAdminPortfolios();
      } else {
        await refreshUserPortfolios();
        await refreshShayPortfolios()
      }
    } catch (error) {
      console.error('Visibility update error:', error);
      toast.error('ไม่สามารถเปลี่ยนสถานะพอร์ตได้');
    }
  };
  const handleModalSaveSuccess = async () => {
    setIsPortModalOpen(false);
    await refreshUserPortfolios();
     await refreshShayPortfolios()
  };
const displayPortfolios = userPortfolios.map(p => ({
  ...p,
  // ถ้า V2 ใช้ portfolioId แต่ V1 ใช้ portId ให้แก้ตรงนี้ให้ตรงกับที่ Component คาดหวัง
  id: p.portId || p.portfolioId, 
  name: p.name || 'Unnamed'
}));
  return (
    <div className="w-full p-4 md:p-2 text-white min-h-screen">
      {/* เปลี่ยนหัวข้ออัตโนมัติตามหน้า */}
      {/* <h1 className="text-2xl md:text-3xl font-bold mb-6 text-yellow-400">
        {isAdminView ? 'ภาพรวมพอร์ตแอดมิน (Public)' : 'ภาพรวมพอร์ตการลงทุน'}
      </h1> */}
      {/* ---------------- แสดงข้อมูลตาม URL (ไม่มีปุ่ม Tab แล้ว) ---------------- */}
      {loading ? (
        <div className="flex justify-center items-center h-40">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-yellow-400"></div>
          <span className="ml-3 text-gray-400">กำลังโหลดข้อมูลพอร์ต...</span>
        </div>
      ) : !isAdminView ? (
        <div className="animate-fadeIn">
          <PortfolioAllocationBoxV2
            portfolios={userPortfolios}
            shayPortfolios={shayPortfolios}
            onAddPortfolio={handleAddPortfolio}
            onEditPortfolio={handleEditPortfolio}
            onDeletePortfolio={handleDeletePortfolio}
            onToggleVisibility={handleToggleVisibility} // ✅ 3. ส่งฟังก์ชันลงไปให้กล่องลูก
            isAdmin={userInfo?.isAdmin}
            currency={currency}
            handleCurrencyToggle={handleCurrencyToggle}
            setPortfolios={() => {
              refreshUserPortfolios()
               refreshShayPortfolios()
              }}
          />
        </div>
      ) : (
        <div className="animate-fadeIn">
          <PortfolioAllocationBoxV2Admin
            portfolios={adminPortfolios}
            onAddPortfolio={handleAddPortfolio}
            onEditPortfolio={handleEditPortfolio}
            onToggleVisibility={handleToggleVisibility} // ✅ 3. ส่งฟังก์ชันลงไปให้กล่องลูก
            onDeletePortfolio={handleDeletePortfolio}
            isAdmin={userInfo?.isAdmin} // ตรวจสอบจาก userInfo ว่าเป็นแอดมินหรือไม่
            refreshPortfolios={refreshAdminPortfolios}
          />
        </div>
      )}

      {/* ---------------- วาง Component Modal ไว้ด้านล่างสุด ---------------- */}
      {isPortModalOpen && (
        <AddEditPortfolioV2Modal
          isOpen={isPortModalOpen}
          onClose={() => setIsPortModalOpen(false)}
          onSave={handleModalSaveSuccess}
          initialData={editPortfolioData}
          allPortfolios={userPortfolios} // ✅ เพิ่มบรรทัดนี้!
        />
      )}

      {isConfigPortPopupOpen && (
        <ConfigTargetPortRatio
          isOpen={isConfigPortPopupOpen}
          onClose={() => setIsConfigPortPopupOpen(false)}
          portfolios={userPortfolios}
          onSave={async () => {
            await refreshUserPortfolios();
            setIsConfigPortPopupOpen(false);
          }}
        />
      )}
    </div>
  );
};

export default PortfolioDashboardV2;